import api from './client'

export interface DocumentFile {
  id: string
  leadId: string
  originalName: string
  mimeType: string
  sizeBytes: number
  label: string | null
  uploadedBy: string
  uploadedByUser?: { id: string; firstName: string; lastName: string }
  createdAt: string
}

export interface DeletedDocumentFile extends DocumentFile {
  deletedAt: string
  deletedBy: string | null
  deletedByUser?: { id: string; firstName: string; lastName: string }
}

const base = (cid: string, lid: string) =>
  `/companies/${cid}/leads/${lid}/documents`

export const documentsApi = {
  list: (cid: string, lid: string) =>
    api.get<DocumentFile[]>(base(cid, lid)),

  upload: (cid: string, lid: string, formData: FormData) =>
    api.post<DocumentFile>(base(cid, lid), formData),

  updateLabel: (cid: string, lid: string, id: string, label: string | null) =>
    api.patch<DocumentFile>(`${base(cid, lid)}/${id}`, { label }),

  softDelete: (cid: string, lid: string, id: string) =>
    api.delete(`${base(cid, lid)}/${id}`),

  stream: (cid: string, lid: string, id: string) =>
    api.get<Blob>(`${base(cid, lid)}/${id}/stream`, { responseType: 'blob' }),

  listDeleted: (cid: string) =>
    api.get<DeletedDocumentFile[]>(`/companies/${cid}/documents/deleted`),

  restore: (cid: string, id: string) =>
    api.patch(`/companies/${cid}/documents/${id}/restore`),

  hardDelete: (cid: string, id: string) =>
    api.delete(`/companies/${cid}/documents/${id}/permanent`),

  emptyBin: (cid: string) =>
    api.delete(`/companies/${cid}/documents/bin`),
}
